{
  "seo": {
    "title": "Topics — Science, Space, Animals & More",
    "description": "Discover topics kids love! Browse questions about science, space, animals, the human body, nature, history, and technology — all explained in a fun way.",
    "keywords": "kids topics, science topics for kids, space for kids, animal facts, human body for kids, nature questions"
  },
  "hero": {
    "tagline": "Choose your adventure!",
    "titlePrefix": "Discover by",
    "titleHighlight": "Topic",
    "subtitle": "Where will curiosity take you today?"
  },
  "cards": {
    "exampleLabel": "Example",
    "items": [
      {
        "name": "Science",
        "description": "Big ideas made simple and exciting for curious kids.",
        "highlights": ["Experiments", "How things work"],
        "sample": "Why do volcanoes erupt?"
      },
      {
        "name": "Space",
        "description": "Stars, planets, and mysteries of the universe.",
        "highlights": ["Planets", "Astronaut life"],
        "sample": "Why does the moon change shape?"
      },
      {
        "name": "Animals",
        "description": "Amazing creatures from oceans, forests, and beyond.",
        "highlights": ["Habitats", "Animal behavior"],
        "sample": "How do dolphins sleep?"
      },
      {
        "name": "Human Body",
        "description": "Learn how your body grows, heals, and stays strong.",
        "highlights": ["Body systems", "Healthy habits"],
        "sample": "Why does our heart beat faster when we run?"
      },
      {
        "name": "Nature",
        "description": "Explore weather, plants, and the world around us.",
        "highlights": ["Weather", "Plants and ecosystems"],
        "sample": "Why do leaves change color?"
      },
      {
        "name": "Technology",
        "description": "Friendly explanations for modern tools and inventions.",
        "highlights": ["Computers", "Everyday tech"],
        "sample": "How does Wi-Fi reach our devices?"
      }
    ]
  },
  "cta": {
    "title": "Ready to Explore All Topics?",
    "subtitle": "Create an account to unlock personalized learning and continue where your child left off.",
    "browse": "Browse All Questions",
    "start": "Start Free"
  }
}
